export default __webpack_public_path__ + "static/media/10.13255640.jpg";